/* global $ */
/* global gon */
import Question from '../shared/question'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3 })

export default class Quiz {
  constructor() {
    this.currentQuestion = null
    this.quiz = null
  }

  async start() {
    await this.getQuiz()
    this.totalQuestions = this.quiz.total_questions
    this.totalQuestionsAnswered = this.quiz.total_questions_answered
    this.currentQuestion = new Question(this.quiz.question_set.pop())
    this.updateUI()
  }

  async getQuiz() {
    const quiz = await axios.get(`/quizzes/${gon.quiz_id}/status.json`)
    this.quiz = quiz.data
  }

  async submitAnswer(answer) {
    await axios.post(`/tests/${gon.quiz_id}/submit_answer.json`, {
      user_answer: {
        question_id: this.currentQuestion.id,
        answer,
        duration: (new Date() - this.currentQuestion.startTime) / 1000,
      },
    })
    this.totalQuestionsAnswered += 1
    if (!this.quiz.question_set.length > 0) {
      this.finish()
    } else {
      this.currentQuestion = new Question(this.quiz.question_set.pop())
      this.updateUI()
    }
  }

  async finish() {
    await this.getQuiz()

    $('.total-questions').html(this.totalQuestions)
    $('#score').html((this.quiz.score || 0) + '%')
    $('#duration').html(this.quiz.total_time_in_minutes)

    if (this.quiz.categories.length > 0) {
      $('table#category-results').removeClass('d-none')
      let result = ''
      this.quiz.categories.forEach((category) => {
        result += `<tr><td>${category.name}</td><td class='text-right'>${category.score}%</td><tr>`
      })
      $('table#category-results tbody').html(result)
    }

    if (this.quiz.units.length > 0) {
      $('table#unit-results').removeClass('d-none')
      let result = ''
      this.quiz.units.forEach((unit) => {
        result += `<tr><td>${unit.name}</td><td class='text-right'>${unit.score}%</td><tr>`
      })
      $('table#unit-results tbody').html(result)
    }

    $('.question-wrapper').addClass('d-none')
    $('.test-results').removeClass('d-none')
  }

  updateUI() {
    this.correctAnswers = []
    let correctAnswers = this.correctAnswers
    let currentQuestion = this.currentQuestion
    let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

    // Scroll to top for mobile
    $(window).scrollTop(0)

    // Set progress bar
    const progress = Math.round(
      ((this.totalQuestionsAnswered + 1) / this.totalQuestions) * 100
    )
    $('#progress-bar').css('width', `${progress}%`)

    // Populate question
    $('#prompt').html(currentQuestion.prompt)
    if (currentQuestion.promptImageUrl) {
      $('img#prompt-image').attr('src', currentQuestion.promptImageUrl).show()
    } else {
      $('img#prompt-image').attr('src', '').hide()
    }
    // Populate answers
    let answers = [...currentQuestion.answers]
    $("input[name='option']").each(function () {
      // clear previous answers
      $(this).prop('checked', false)
      $(this).next('label').find('span.option').html('')
      $(this).next('label').find('span.option-letter').html('')

      // set new answers
      const answer = answers.shift()
      if (answer) {
        $(this).val(answer.id)
        $(this).next('label').find('span.option').html(answer.value)
        const letter = letters.shift()
        $(this).next('label').find('span.option-letter').html(letter)
        if (answer.correct) {
          correctAnswers.push(letter)
        }
        $(this).parent().show()
      } else {
        $(this).parent().hide()
      }
      if (currentQuestion.type === 'SingleResponseQuestion') {
        $("input[name='option']").prop('type', 'radio')
        $("input[name='option']").prop('disabled', '')
      } else if (currentQuestion.type === 'MultiResponseQuestion') {
        $("input[name='option']").prop('type', 'checkbox')
        $("input[name='option']").prop('disabled', '')
      }
    })

    // console.log(
    //   `Question ${this.currentQuestion.id}:${this.correctAnswers} loaded for unit ${this.currentQuestion.unitId}, topic ${this.currentQuestion.topicId}, and category ${this.currentQuestion.categoryId}.`
    // );

    // Setup ticket modal for question ticket
    $('#submit-ticket').data('question-id', this.currentQuestion.id)
    $('#question-ticket-prompt').html(this.currentQuestion.prompt)
    $('.modal-body .unit-ticket').hide()
    $('.modal-body .question-ticket').show()
  }
}
